module.exports = __webpack_public_path__ + "img/1.8f317b55.png";